import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
const store = new Vuex.Store({
  state:{
    count:1,
    numtype: 'NUM'
  },
  mutations: {
    setStoreNumtype(state, value){
      state.numtype = value
      localStorage.setItem('numtype', value);
    }
  },
  getters:{
    getStoreCount: function (state) {
      return state.count + 1;
    },
    getStoreNumtype: function (state) {
      return state.numtype
    }
  },
  actions: {
    loadData({ commit }) {
      let data = localStorage.getItem('numtype');
      if (data) {
        commit('setStoreNumtype', data);
      }
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js